import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface UserRoleChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  currentRole: 'admin' | 'user';
  userName: string;
  isLoading?: boolean;
}

export const UserRoleChangeModal: React.FC<UserRoleChangeModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  currentRole,
  userName,
  isLoading = false,
}) => {
  const isUpgrading = currentRole === 'user';

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {isUpgrading ? 'Upgrade to Admin' : 'Downgrade to User'}
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-4">
            <p className="text-foreground">
              {isUpgrading ? (
                <>
                  Giving admin access to <span className="font-semibold">{userName}</span> means they are allowed to add other users to the system and make them admins. Administrators also have full edit access to all organisations, their data and experiments.
                </>
              ) : (
                <>
                  Removing administrator access for <span className="font-semibold">{userName}</span> will take effect from the next time they log in. They will no longer be able to see any organisations except for the ones they are explicitly added to and cannot edit experiments or invite other users.
                </>
              )}
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isLoading}>
            {isLoading ? 'Processing...' : (isUpgrading ? 'Upgrade to Admin' : 'Downgrade to User')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
